import {Types} from "../actions/courseActions";

const courseReducers = (state, action) => {
    switch(action.type) {
        case Types.COURSES_DOWNLOADING_CERTIFICATE: {
            let newState = {...state};
            newState.courseCertificateDownloading = action.downloading;
            return newState;
        }
        case Types.COURSES_DOWNLOADED_CERTIFICATE: {
            let newState = {...state};
            newState.courseCertificateDownloading = action.downloading;
            return newState;
        }
        default: return state;
    }
}

export default courseReducers;